import { ArrowLeft } from 'lucide-react';
import { AuditRequestForm } from './AuditRequestForm';

/**
 * Direct Reader Path Audit request for visitors who already see fit
 * and do not need the Score first. Soft secondary to the Score path.
 */
export function AuditRequestPage() {
  return <>
      <a href="#main-content" className="skip-link" data-id="element-63" data-mp="3my8db0jtm3sf">
        Skip to main content
      </a>
      <main id="main-content" className="min-h-screen w-full bg-paper px-6 py-8 text-text md:px-10 md:py-12" data-id="element-64" data-mp="3n02zei6tw1y3">
      <div className="mx-auto max-w-4xl" data-id="element-65" data-mp="3dxjxc0av9tcw">
        <a href="/" className="inline-flex items-center gap-2 rounded-xl px-2 py-2 text-sm font-semibold text-navy transition-colors hover:bg-paper-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass" data-id="element-66" data-mp="3dylk3218w4ag">
          <ArrowLeft className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="3480fmxyw45jm" />
          Back to Author Leverage
        </a>

        <header className="border-b border-gray-200 pb-10 pt-10 text-center md:pb-12" data-id="element-68" data-mp="2qa2ewvdhs7ml">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-seaglass" data-id="element-69" data-mp="2v69abu89i0qa">
            Reader Path Audit
          </p>
          <h1 className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-tight text-navy md:text-5xl" data-id="element-70" data-mp="3eravs0oyrg3c">
            Already clear this is a fit?
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-text-muted" data-id="element-71" data-mp="3sqk30av6yzv6">
            Request a Reader Path Audit and we’ll look at whether the path is
            worth building — without making you run the Score first.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-text-muted" data-id="element-72" data-mp="2v3l9ua3pka21">
            Still unsure?{' '}
            <a href="/" className="font-medium text-navy underline decoration-seaglass/40 underline-offset-4 hover:text-seaglass hover:decoration-seaglass" data-id="element-73" data-mp="39t9e9k76rotz">
              Start with the Reader-to-Revenue Score
            </a>{' '}
            instead — eight questions, then the Audit if it fits.
          </p>
        </header>

        <AuditRequestForm score={null} helperText="Share a little context about your book and offers. We’ll follow up by email about a Reader Path Audit." data-id="element-74" data-mp="2cck3v2467e8z" />
      </div>
    </main>
    </>;
}